import React from "react";
import { motion } from "framer-motion";
import { X, ArrowLeft } from "lucide-react";
import { useLanguage } from "../contexts/LanguageContext";
import MarkdownRenderer from "../Components/MarkdownRenderer";

export default function PrivacyPolicy({ onClose }) {
    const { t, language } = useLanguage();

    const content = {
        it: {
            title: "Privacy Policy",
            lastUpdated: "Ultimo aggiornamento: 16 Febbraio 2026",
            sections: [
                {
                    title: "1. Titolare del Trattamento",
                    content: `Il Titolare del trattamento dei dati personali è ELLEGI S.r.l., con sede legale in Viale Vittorio Veneto, 6 - 20124 Milano (MI), Italia.

**Dati di contatto:**
- Email: comm@lg-mi.it
- Telefono: +39 02 2895741
- Sito web: www.lg-mi.it`
                },
                {
                    title: "2. Tipologie di Dati Raccolti",
                    content: `In conformità al Regolamento UE 2016/679 (GDPR), raccogliamo e trattiamo le seguenti categorie di dati personali:

**Dati forniti volontariamente:**
- Nome e cognome
- Indirizzo email
- Numero di telefono
- Azienda/organizzazione di appartenenza
- Messaggi e comunicazioni inviate tramite i form di contatto

**Dati raccolti automaticamente:**
- Indirizzo IP
- Tipo di browser e dispositivo
- Pagine visitate e tempo di permanenza
- Cookie tecnici e analitici (vedi Cookie Policy)`
                },
                {
                    title: "3. Base Giuridica e Finalità del Trattamento",
                    content: `I dati personali sono trattati per le seguenti finalità e basi giuridiche:

**a) Gestione delle richieste (base giuridica: esecuzione di misure precontrattuali - art. 6.1.b GDPR)**
- Rispondere alle richieste di informazioni
- Fornire preventivi e consulenze
- Gestire ordini e servizi richiesti

**b) Marketing diretto (base giuridica: consenso - art. 6.1.a GDPR)**
- Invio di newsletter e comunicazioni commerciali
- Informazioni su nuovi prodotti e servizi
- Inviti a eventi e fiere

**c) Obblighi legali (base giuridica: obbligo legale - art. 6.1.c GDPR)**
- Adempimenti fiscali e contabili
- Conservazione della documentazione obbligatoria

**d) Miglioramento del sito (base giuridica: legittimo interesse - art. 6.1.f GDPR)**
- Analisi statistiche anonime
- Ottimizzazione dell'esperienza utente
- Sicurezza informatica`
                },
                {
                    title: "4. Periodo di Conservazione",
                    content: `I dati personali sono conservati per il tempo strettamente necessario alle finalità per cui sono stati raccolti:

- **Richieste di contatto:** 24 mesi dalla ricezione
- **Clienti:** 10 anni per obblighi fiscali e contabili
- **Newsletter:** fino alla revoca del consenso
- **Cookie analitici:** massimo 24 mesi
- **Log del server:** 12 mesi

Decorsi tali termini, i dati saranno cancellati o resi anonimi in modo irreversibile.`
                },
                {
                    title: "5. Diritti dell'Interessato",
                    content: `In qualità di interessato, hai i seguenti diritti ai sensi degli artt. 15-22 del GDPR:

**Diritto di accesso (art. 15):** Ottenere conferma dell'esistenza dei tuoi dati e riceverne copia.

**Diritto di rettifica (art. 16):** Richiedere la correzione di dati inesatti o incompleti.

**Diritto alla cancellazione (art. 17):** Richiedere la cancellazione dei dati (diritto all'oblio).

**Diritto di limitazione (art. 18):** Richiedere la limitazione del trattamento.

**Diritto alla portabilità (art. 20):** Ricevere i dati in formato strutturato e trasferirli ad altro titolare.

**Diritto di opposizione (art. 21):** Opporti al trattamento per motivi legittimi.

**Diritto di revoca del consenso:** Revocare il consenso in qualsiasi momento.

**Diritto di proporre reclamo:** Presentare reclamo all'Autorità Garante per la Protezione dei Dati Personali (www.garanteprivacy.it).

Per esercitare i tuoi diritti, contattaci a: comm@lg-mi.it`
                },
                {
                    title: "6. Destinatari dei Dati",
                    content: `I dati personali possono essere comunicati a:

- **Personale autorizzato** di ELLEGI S.r.l. per le finalità sopra indicate
- **Fornitori di servizi** che agiscono in qualità di responsabili del trattamento (hosting, email marketing, CRM)
- **Autorità pubbliche** quando richiesto per legge
- **Consulenti e professionisti** per adempimenti legali e fiscali

Non vengono effettuate comunicazioni a terzi per finalità commerciali senza il tuo consenso esplicito.`
                },
                {
                    title: "7. Trasferimento dei Dati",
                    content: `I dati personali sono conservati su server localizzati nell'Unione Europea. Qualora fosse necessario trasferire dati al di fuori dello Spazio Economico Europeo, garantiamo l'adozione di adeguate misure di salvaguardia conformi al GDPR (clausole contrattuali standard, decisioni di adeguatezza).`
                },
                {
                    title: "8. Sicurezza dei Dati",
                    content: `Adottiamo misure tecniche e organizzative adeguate per proteggere i dati personali da:

- Accessi non autorizzati
- Divulgazione illecita
- Perdita o distruzione accidentale
- Modifiche non autorizzate

Le misure includono: cifratura delle comunicazioni (SSL/TLS), firewall, backup regolari, controlli di accesso, formazione del personale.`
                },
                {
                    title: "9. Cookie e Tecnologie di Tracciamento",
                    content: `Il sito utilizza cookie tecnici e, previo consenso, cookie analitici. Per informazioni dettagliate, consulta la nostra Cookie Policy.`
                },
                {
                    title: "10. Modifiche alla Privacy Policy",
                    content: `Questa Privacy Policy può essere aggiornata periodicamente. Le modifiche sostanziali saranno comunicate tramite avviso sul sito o via email. Ti invitiamo a consultare regolarmente questa pagina.`
                },
                {
                    title: "11. Contatti",
                    content: `Per qualsiasi domanda o richiesta relativa alla privacy, puoi contattarci:

**ELLEGI S.r.l.**
Viale Vittorio Veneto, 6
20124 Milano (MI), Italia
Email: comm@lg-mi.it
Tel: +39 02 2895741`
                }
            ]
        },
        en: {
            title: "Privacy Policy",
            lastUpdated: "Last updated: February 16, 2026",
            sections: [
                {
                    title: "1. Data Controller",
                    content: `The Data Controller for personal data is ELLEGI S.r.l., with registered office at Viale Vittorio Veneto, 6 - 20124 Milan (MI), Italy.

**Contact information:**
- Email: comm@lg-mi.it
- Phone: +39 02 2895741
- Website: www.lg-mi.it`
                },
                {
                    title: "2. Types of Data Collected",
                    content: `In accordance with EU Regulation 2016/679 (GDPR), we collect and process the following categories of personal data:

**Data provided voluntarily:**
- First and last name
- Email address
- Phone number
- Company/organization affiliation
- Messages and communications sent through contact forms

**Automatically collected data:**
- IP address
- Browser type and device
- Pages visited and time spent
- Technical and analytical cookies (see Cookie Policy)`
                },
                {
                    title: "3. Legal Basis and Purpose of Processing",
                    content: `Personal data is processed for the following purposes and legal bases:

**a) Request management (legal basis: performance of pre-contractual measures - art. 6.1.b GDPR)**
- Responding to information requests
- Providing quotes and consultations
- Managing orders and requested services

**b) Direct marketing (legal basis: consent - art. 6.1.a GDPR)**
- Sending newsletters and commercial communications
- Information about new products and services
- Invitations to events and trade fairs

**c) Legal obligations (legal basis: legal obligation - art. 6.1.c GDPR)**
- Tax and accounting compliance
- Retention of mandatory documentation

**d) Website improvement (legal basis: legitimate interest - art. 6.1.f GDPR)**
- Anonymous statistical analysis
- User experience optimization
- IT security`
                },
                {
                    title: "4. Retention Period",
                    content: `Personal data is retained for the time strictly necessary for the purposes for which it was collected:

- **Contact requests:** 24 months from receipt
- **Customers:** 10 years for tax and accounting obligations
- **Newsletter:** until consent is withdrawn
- **Analytical cookies:** maximum 24 months
- **Server logs:** 12 months

After these periods, data will be deleted or made irreversibly anonymous.`
                },
                {
                    title: "5. Data Subject Rights",
                    content: `As a data subject, you have the following rights under articles 15-22 of the GDPR:

**Right of access (art. 15):** Obtain confirmation of the existence of your data and receive a copy.

**Right to rectification (art. 16):** Request correction of inaccurate or incomplete data.

**Right to erasure (art. 17):** Request deletion of data (right to be forgotten).

**Right to restriction (art. 18):** Request restriction of processing.

**Right to data portability (art. 20):** Receive data in a structured format and transfer it to another controller.

**Right to object (art. 21):** Object to processing for legitimate reasons.

**Right to withdraw consent:** Withdraw consent at any time.

**Right to lodge a complaint:** File a complaint with the Italian Data Protection Authority (www.garanteprivacy.it).

To exercise your rights, contact us at: comm@lg-mi.it`
                },
                {
                    title: "6. Data Recipients",
                    content: `Personal data may be disclosed to:

- **Authorized personnel** of ELLEGI S.r.l. for the purposes indicated above
- **Service providers** acting as data processors (hosting, email marketing, CRM)
- **Public authorities** when required by law
- **Consultants and professionals** for legal and tax compliance

No data is disclosed to third parties for commercial purposes without your explicit consent.`
                },
                {
                    title: "7. Data Transfer",
                    content: `Personal data is stored on servers located in the European Union. Should it be necessary to transfer data outside the European Economic Area, we ensure the adoption of adequate safeguards compliant with GDPR (standard contractual clauses, adequacy decisions).`
                },
                {
                    title: "8. Data Security",
                    content: `We adopt appropriate technical and organizational measures to protect personal data from:

- Unauthorized access
- Unlawful disclosure
- Accidental loss or destruction
- Unauthorized modification

Measures include: communication encryption (SSL/TLS), firewalls, regular backups, access controls, staff training.`
                },
                {
                    title: "9. Cookies and Tracking Technologies",
                    content: `The website uses technical cookies and, with consent, analytical cookies. For detailed information, please consult our Cookie Policy.`
                },
                {
                    title: "10. Changes to Privacy Policy",
                    content: `This Privacy Policy may be updated periodically. Substantial changes will be communicated via notice on the website or by email. We invite you to regularly consult this page.`
                },
                {
                    title: "11. Contact",
                    content: `For any questions or requests regarding privacy, you can contact us:

**ELLEGI S.r.l.**
Viale Vittorio Veneto, 6
20124 Milan (MI), Italy
Email: comm@lg-mi.it
Tel: +39 02 2895741`
                }
            ]
        }
    };

    const currentContent = language === 'it' ? content.it : content.en;

    return (
        <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            className="fixed inset-0 z-[200] bg-[--bg-primary] overflow-y-auto"
        >
            {/* Header */}
            <div className="sticky top-0 z-10 bg-[--bg-primary]/95 backdrop-blur-sm border-b border-[--border-color]">
                <div className="max-w-4xl mx-auto px-6 py-4 flex items-center justify-between">
                    <button
                        onClick={onClose}
                        className="flex items-center gap-2 text-[--text-secondary] hover:text-[--accent] transition-colors"
                    >
                        <ArrowLeft className="w-5 h-5" />
                        <span>{language === 'it' ? 'Torna alla Home' : 'Back to Home'}</span>
                    </button>
                    <button
                        onClick={onClose}
                        className="w-10 h-10 rounded-full bg-[--accent]/20 flex items-center justify-center hover:bg-[--accent] transition-colors group"
                    >
                        <X className="w-5 h-5 text-[--accent] group-hover:text-black transition-colors" />
                    </button>
                </div>
            </div>

            {/* Content */}
            <div className="max-w-4xl mx-auto px-6 py-12">
                <motion.div
                    initial={{ opacity: 0, y: 20 }}
                    animate={{ opacity: 1, y: 0 }}
                    transition={{ delay: 0.1 }}
                >
                    <h1 className="text-4xl md:text-5xl font-bold text-[--accent] mb-2">
                        {currentContent.title}
                    </h1>
                    <p className="text-sm text-[--text-secondary] mb-12">
                        {currentContent.lastUpdated}
                    </p>

                    <div className="space-y-8">
                        {currentContent.sections.map((section, index) => (
                            <motion.div
                                key={index}
                                initial={{ opacity: 0, y: 20 }}
                                animate={{ opacity: 1, y: 0 }}
                                transition={{ delay: 0.1 * (index + 1) }}
                                className="bg-[--bg-secondary] p-6 rounded-lg border border-[--border-color]"
                            >
                                <h2 className="text-xl font-bold text-[--text-primary] mb-4">
                                    {section.title}
                                </h2>
                                <MarkdownRenderer content={section.content} />
                            </motion.div>
                        ))}
                    </div>

                    {/* Footer CTA */}
                    <motion.div
                        initial={{ opacity: 0 }}
                        animate={{ opacity: 1 }}
                        transition={{ delay: 0.5 }}
                        className="mt-12 p-6 bg-[--accent]/10 border border-[--accent]/20 rounded-lg text-center"
                    >
                        <p className="text-[--text-primary] mb-4">
                            {language === 'it'
                                ? 'Hai domande sulla nostra Privacy Policy?'
                                : 'Do you have questions about our Privacy Policy?'}
                        </p>
                        <a
                            href="mailto:comm@lg-mi.it"
                            className="inline-flex items-center gap-2 px-6 py-3 bg-[--accent] hover:bg-[--accent-hover] text-black font-semibold rounded-lg transition-colors"
                        >
                            {language === 'it' ? 'Contattaci' : 'Contact Us'}
                        </a>
                    </motion.div>
                </motion.div>
            </div>
        </motion.div>
    );
}
